module.exports = __webpack_public_path__ + "static/hiral-bad656897e750f3527490b5efa51e1b8.png";